import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "../src/Pages/Home";
import Leaderboard from "../src/Pages/Leaderboard";
import Register from "../src/Pages/register";
import Profile from './Pages/profile';

function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path='/leaderboard' element={<Leaderboard />} />
					<Route path='/register' element={<Register />} />
					<Route path='/profile' element={<Profile />} />

				</Routes>
			</BrowserRouter>

		</div>

	)
}

export default App;
